import { Route } from '@angular/router';
import { SummaryMainComponent } from './components/summary-main/summary-main.component';
import { SummaryService } from './services/summary.service';
import { UserService } from '../api/services/user.service';
import { TravelService } from '../api/services/travel.service';
import { VersionControlService } from '../api/services/version-control.service';

export default [
  {
    path: '',
    component: SummaryMainComponent,
    providers: [
      SummaryService,
      UserService,
      TravelService,
      VersionControlService
    ]
  },
] as Route[];